import React from "react";
import Grid from "../Grid/Grid";
import { cards } from "../index";
import styles from "./DynamicReportsGrid.module.sass";
import { useGlobalValue } from "../../state/GlobalProvider";
const getCardForType = (type, cards) => {
  switch (type) {
    case "bar":
      {
        return cards.FactsComparisonCard;
      }
    case "tops":
      {
        return cards.TopsCard;
      }
    default:
      {
        return null;
      }
  }
};
const DynamicReportsGrid = props => {
  const {
    data: gridData,
    modifiers
  } = props;
  const {
    i18n
  } = useGlobalValue();
  if (!gridData || !gridData.length) {
    return null;
  }
  const columnsTemplate = [];
  const items = [];
  const gridCards = [];
  gridData.forEach(dataset => {
    const {
      colspan,
      title,
      tabs,
      icon,
      data,
      links,
      dataLabels,
      currency,
      type,
      currencyType = {}
    } = dataset;
    columnsTemplate.push(colspan);
    items.push({
      title: i18n(title),
      icon,
      tabs,
      data,
      dataLabels,
      currency,
      links,
      currencyType
    });
    gridCards.push(getCardForType(type, cards));
  });
  const modifiersClasses = (modifiers || []).map(m => styles[m]).filter(m => m).join(" ");
  return /*#__PURE__*/React.createElement("div", {
    className: `${styles["root"]} ${modifiersClasses}`
  }, /*#__PURE__*/React.createElement(Grid, {
    modifiers: (modifiers || []).filter(m => m.match(/^--cardholder-.*/gi)),
    columnsTemplate: columnsTemplate,
    items: items,
    cards: gridCards
  }));
};
export default DynamicReportsGrid;